import { type ReactNode, memo } from 'react';

import { GlobalErrorPage } from './global-error';
import { SentryErrorBoundary } from './sentry-error-boundary';

type Props = {
  children: ReactNode;
};

export const AppErrorBoundary = memo((props: Props) => {
  return (
    <SentryErrorBoundary
      componentId="app-error-boundary"
      renderError={({ sentryEventId }) => {
        // TODO: Replace this placeholder design
        return <GlobalErrorPage sentryEventId={sentryEventId || undefined} />;
      }}
    >
      {props.children}
    </SentryErrorBoundary>
  );
});
